(function () {
  'use strict';

  /* ---------- Review carousels ---------- */
  function initCarousel(root) {
    var viewport = root.querySelector('[data-mt-viewport]');
    var prev = root.querySelector('[data-mt-prev]');
    var next = root.querySelector('[data-mt-next]');
    if (!viewport) return;
    var slides = viewport.children;
    var index = 0;

    function perView() {
      return window.innerWidth >= 900
        ? parseInt(root.getAttribute('data-cols-desktop'), 10) || 3
        : parseInt(root.getAttribute('data-cols-phone'), 10) || 1;
    }
    function maxIndex() {
      return Math.max(0, slides.length - perView());
    }
    function update() {
      var pv = perView();
      var max = maxIndex();
      if (index > max) index = max;
      viewport.style.transform = 'translate3d(' + (-index * (100 / pv)) + '%,0,0)';
      if (prev) prev.disabled = index <= 0;
      if (next) next.disabled = index >= max;
    }
    if (prev) prev.addEventListener('click', function () { index = Math.max(0, index - 1); update(); });
    if (next) next.addEventListener('click', function () { index = Math.min(maxIndex(), index + 1); update(); });
    window.addEventListener('resize', update);

    /* simple swipe support */
    var startX = null;
    viewport.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    viewport.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) { index = dx < 0 ? Math.min(maxIndex(), index + 1) : Math.max(0, index - 1); update(); }
      startX = null;
    });
    update();
  }

  /* ---------- Countdown (display only: restarts from the configured time on every page load) ---------- */
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function initCountdown(el) {
    var total = parseInt(el.getAttribute('data-seconds'), 10) || 0;
    var out = el.querySelector('[data-mt-time]');
    if (!out) return;
    function render() {
      var s = Math.max(0, total);
      var h = Math.floor(s / 3600);
      var m = Math.floor((s % 3600) / 60);
      var sec = s % 60;
      out.textContent = pad(h) + ':' + pad(m) + ':' + pad(sec);
    }
    render();
    setInterval(function () { if (total > 0) { total -= 1; } render(); }, 1000);
  }

  function boot() {
    var carousels = document.querySelectorAll('[data-mt-carousel]:not([data-mt-ready])');
    for (var i = 0; i < carousels.length; i++) { carousels[i].setAttribute('data-mt-ready', '1'); initCarousel(carousels[i]); }
    var timers = document.querySelectorAll('[data-mt-countdown]:not([data-mt-ready])');
    for (var j = 0; j < timers.length; j++) { timers[j].setAttribute('data-mt-ready', '1'); initCountdown(timers[j]); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  /* re-init inside the theme editor when sections reload */
  document.addEventListener('shopify:section:load', boot);
})();
